import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface CoverLetterReturn {
  mode: ComputedRef<InputMode>
  coverLetter: ComputedRef<File | File[] | null>
  setCoverLetter: (file: File | File[] | null) => void
}

export const useCoverLetter = (): CoverLetterReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && !tutorApplicationStore.form.coverLetter))
  const coverLetter = computed(() => tutorApplicationStore.form.coverLetter)

  const setCoverLetter = (file: File | File[] | null) => {
    tutorApplicationStore.setField('coverLetter', file)
  }

  return {
    mode,
    coverLetter,
    setCoverLetter,
  }
}
